import { apiHost } from '@libs/providers/api-host.provider';
import { HttpStatuses } from './blog.service';

function route(slug: string) {
  return `${apiHost()}/web/articles/${slug}`;
}

export function increaseNumberOfViews(slug: string) {
  const url = route(slug);
  return fetch(`${url}/views`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  }).then((response) => {
    switch (response.status) {
      case HttpStatuses.received:
      case HttpStatuses.created:
        return 'ok';
      case HttpStatuses.notFound:
        throw new Error('Not found');
      default:
        throw new Error('Smth bad');
    }
  });
}

export function getArticle(slug: string) {
  /** actually id is an article slug */
  const articleUrl = `${apiHost()}/web/articles/${encodeURI(slug)}`;
  return fetch(articleUrl).then((response) => {
    switch (response.status) {
      case HttpStatuses.received:
        return response.json();
      case HttpStatuses.notFound:
        throw new Error('Not found');
      default:
        throw new Error('Smth bad');
    }
  });
}

export function setArticleRating(articleId: string, visitorSecret: string, rating: number) {
  return fetch(`${apiHost()}/web/articles/rating`, {
    method: 'PUT',
    body: JSON.stringify({
      articleId,
      visitorSecret,
      grade: rating,
    }),
    headers: { 'Content-Type': 'application/json' },
  }).then((response) => {
    switch (response.status) {
      case HttpStatuses.received:
      case HttpStatuses.created:
        return response.json();
      case HttpStatuses.notFound:
        throw new Error('Not found');
      default:
        throw new Error('Smth bad');
    }
  });
}

export function getArticleRating(articleId: string, visitorSecret: string) {
  return fetch(`${apiHost()}/web/articles/rating/${articleId}/${visitorSecret}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }).then((response) => {
    switch (response.status) {
      case HttpStatuses.received:
      case HttpStatuses.created:
        return response.json();
      case HttpStatuses.notFound:
        throw new Error('Not found');
      default:
        throw new Error('Smth bad');
    }
  });
}
